module.exports = __webpack_public_path__ + "img/30007.81671680.png";